import { useDispatch, useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { PropsWithChildren } from "react";
import { RootState } from "../../../../redux/store";
import { showAlertMessage } from "../../../../redux/reducer/alert-message.reducer";
import { RoleEnum } from "../../enums/role.enum";

type RequireAuthProps = PropsWithChildren & {
  roles: RoleEnum[];
};

export const RequireAuth = ({ children, roles }: RequireAuthProps) => {
  const session = useSelector(
    (state: RootState) => state.session
  );
  const dispatch = useDispatch();

  if (roles.length === 0 || (session?.user?.role && roles.includes(session.user.role))) {
    return <>{children}</>;
  }
  
  dispatch(showAlertMessage({
    alertMessageText: 'A funkció eléréséhez be kell jelentkeznie.',
    alertMessageType: 'error'
  }));

  return <Navigate to='/cms/login' />;
};
